import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

const TeamSection = () => {
  const [index, setIndex] = useState(0);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamContent, setTeamContent] = useState({
    title: "Our Team Members",
    text: "Lorem Ipsum Is Simply Dummy Text Of The Printing And Typesetting Industry.",
  });

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/team-member-list"
        );
        const result = await response.json();

        if (result?.status && Array.isArray(result?.data)) {
          setTeamMembers(result.data);
        }
      } catch (error) {
        console.error("Team members API fetch error:", error);
      }
    };

    const fetchTeamHeadingContent = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/team-member-headingtitle"
        );
        const result = await response.json();

        if (result?.status && result?.data) {
          setTeamContent({
            title: result?.data?.title || "Our Team Members",
            text:
              result?.data?.text ||
              "Lorem Ipsum Is Simply Dummy Text Of The Printing And Typesetting Industry.",
          });
        }
      } catch (error) {
        console.error("Team heading API fetch error:", error);
      }
    };

    fetchTeamMembers();
    fetchTeamHeadingContent();
  }, []);

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const memberSlides = chunkArray(teamMembers, 2);

  const handlePrev = () => {
    if (memberSlides.length === 0) return;
    setIndex((prev) => (prev === 0 ? memberSlides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    if (memberSlides.length === 0) return;
    setIndex((prev) => (prev === memberSlides.length - 1 ? 0 : prev + 1));
  };

  const TeamCard = ({ member }) => (
    <div className="col-md-6">
      <div
        style={{
          backgroundColor: "#fff",
          padding: "50px 35px",
          borderRadius: "0",
          boxShadow: "0 15px 40px rgba(0,0,0,0.05)",
          height: "100%",
          position: "relative",
          textAlign: "left",
        }}
      >
        <div className="d-flex align-items-center mb-4">
          <img
            src={member.member_image}
            alt={member.member_name}
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: "20px",
              border: "5px solid #f8f8f8",
            }}
          />
          <div>
            <h4
              style={{
                fontSize: "22px",
                fontWeight: "700",
                margin: 0,
                color: "#000",
              }}
            >
              {member.member_name}
            </h4>
            <span style={{ color: "#888", fontSize: "14px" }}>
              {member.member_post}
            </span>
          </div>
        </div>

        <p
          style={{
            color: "#666",
            fontSize: "14px",
            lineHeight: "1.8",
            margin: 0,
          }}
        >
          {member.member_description}
        </p>
      </div>
    </div>
  );

  const renderStyledHeading = (title) => {
    const words = title?.trim()?.split(" ") || [];
    if (words.length === 0) {
      return (
        <>
          Our Team <br />
          <span style={{ color: "#b21e35" }}>Members</span>
        </>
      );
    }

    if (words.length === 1) {
      return <>{words[0]}</>;
    }

    const lastWord = words[words.length - 1];
    const firstPart = words.slice(0, -1).join(" ");

    return (
      <>
        {firstPart} <br />
        <span style={{ color: "#b21e35" }}>{lastWord}</span>
      </>
    );
  };

  return (
    <section
      className="team-section"
      style={{
        padding: "100px 0",
        backgroundColor: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "50%",
          height: "100%",
          backgroundColor: "#f8f8f8",
          zIndex: 0,
        }}
      ></div>

      <div className="auto-container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row align-items-center">
          <div className="col-lg-4">
            <div style={{ position: "relative" }}>
              <span
                style={{
                  position: "absolute",
                  top: "-80px",
                  left: "120px",
                  fontSize: "180px",
                  color: "#eee",
                  lineHeight: "1",
                  zIndex: -1,
                }}
              >
                “
              </span>

              <h2
                className="mainheadingfont"
                style={{
                  fontSize: "48px",
                  textAlign: "left",
                  fontWeight: "700",
                  color: "#000",
                  lineHeight: "1.1",
                }}
              >
                {renderStyledHeading(teamContent?.title)}
              </h2>

              <p
                className="mainparafont"
                style={{
                  color: "#666",
                  marginTop: "20px",
                  fontSize: "16px",
                  maxWidth: "300px",
                }}
              >
                {teamContent?.text}
              </p>

              {memberSlides.length > 1 && (
                <div className="d-flex gap-3 mt-4">
                  <button
                    onClick={handlePrev}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "50%",
                      border: "none",
                      backgroundColor: "#000",
                      color: "#fff",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </button>

                  <button
                    onClick={handleNext}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "50%",
                      border: "none",
                      backgroundColor: "#b21e35",
                      color: "#fff",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-chevron-right"></i>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-8 teams-members-custom">
            {memberSlides.length > 0 ? (
              <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                controls={false}
                interval={null}
                fade={false}
              >
                {memberSlides.map((slide, slideIndex) => (
                  <Carousel.Item key={slideIndex}>
                    <div className="row g-4 custom-g4">
                      {slide.map((member) => (
                        <TeamCard key={member.id} member={member} />
                      ))}
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;